import React from 'react';
import { AccaResultSaveCustomHead } from '@components/common/customHead';
import ACCAResultSaveTemplate from '@components/acca/result/save';

const AccaResultSavePage = () => (
  <>
    <AccaResultSaveCustomHead />
    <ACCAResultSaveTemplate />
  </>
);

export default AccaResultSavePage;
